import {Component, Input, OnInit} from '@angular/core';
import {ClosableComponent} from "../../../../../models/closable.component";
import {BsModalRef} from "ngx-bootstrap";
import {AttachmentService} from "../../../../../services/attachment.service";

@Component({
    selector: 'app-banner-image-edit',
    templateUrl: './banner-image-edit.component.html',
    styleUrls: ['./banner-image-edit.component.scss']
})
export class BannerImageEditComponent extends ClosableComponent implements OnInit {

    @Input() imgSlug: string;
    @Input() isSmallText: boolean = true;
    public attachments: any[];

    constructor(private attachmentService: AttachmentService, bsModalRef: BsModalRef) {
        super(bsModalRef);
    }

    ngOnInit() {
        this.loadData();
    }

    private loadData() {
        this.attachmentService.getAllForFrontend().subscribe(attachments => {
            this.attachments = this.attachmentService.addExtraDataForAll(attachments);
            this.attachments.forEach(attachment => {

                attachment.selected = attachment.slug == this.imgSlug;
            })
        });
    }

    save() {
        this.closeWithResponse(this.imgSlug);
    }

    changeSelection(attachment: any) {
        this.attachments.forEach(a =>{
            a.selected = false;
        });
        attachment.selected = true;
        this.imgSlug = attachment.slug;
    }
}
